// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3bedfc05","845":"ba8f2c74"}[chunkId] + ".chunk.js";
};